var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import { View, ScrollView, StyleSheet } from 'react-native';
import R from '../../core-res/R';
import PropTypes from 'prop-types';
import Checkbox from '../Checkbox';
import fieldLocalState from '../../utils/form/fieldLocalState';
import { withTheme } from '../../theme';
class CheckboxGroup extends Component {
    constructor() {
        super(...arguments);
        this.handleButtonSelect = iValue => {
            const { value } = this.props;
            const nextValue = value.findIndex(v => v === iValue) !== -1 ? value.filter(v => v !== iValue) : value.concat(iValue);
            this.props.onChange(nextValue);
        };
    }
    render() {
        const { options, theme } = this.props;
        return (<ScrollView>
        {options.map((_a) => {
            var { value } = _a, rest = __rest(_a, ["value"]);
            return (<View style={[styles.container, { borderBottomColor: theme.borderSubtle }]} key={value}>
            <Checkbox style={[styles.checkbox, { backgroundColor: theme.lightPrimary }]} {...rest} value={this.props.value.findIndex(v => v === value) !== -1} onChange={() => this.handleButtonSelect(value)}/>
          </View>);
        })}
      </ScrollView>);
    }
}
CheckboxGroup.propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        description: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })).isRequired,
    onChange: PropTypes.func,
    value: PropTypes.any,
    theme: PropTypes.object,
};
CheckboxGroup.defaultProps = {
    value: [],
};
const styles = StyleSheet.create({
    container: {
        borderBottomWidth: R.border.width.thin,
    },
    checkbox: {
        padding: R.spacing.m,
    },
});
export default fieldLocalState(withTheme(CheckboxGroup));
